const regexp = /^(?=.*[A-Za-z])(?=.*\d).{8,256}$/;

export const validatePassword = (password: string) => {
    return regexp.test(password);
};

export const passwordRules = "Password must contain at least 8 characters, at least 1 digit and 1 letter";

export const password2Rules = "Password and Password2 are not the same";